import { COLOR_PALETTE } from 'constants/ui';

export const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  padding: 1,
  width: '100%',
  minWidth: 0,
};

export const headerStyles = ({ palette }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: 3,
  borderRadius: 2,
  border: `1px solid ${palette.divider}`,
  backgroundColor: palette.background.paper,
  boxShadow: palette.shadow?.s,
});

export const headerTitleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  justifyContent: 'space-between',
};

// Badge + title share one centred row so the icon lines up with the title
// line itself; the subtitle drops onto its own row, indented to sit under the
// title text (past the badge) — instead of the badge centring on the whole
// two-line block and sagging below the title.
export const headerTitleGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  minWidth: 0,
};

export const headerTitleMainRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  minWidth: 0,
};

// Badge width (36) + the row gap (1.5 -> 12) so the subtitle starts under the
// title text rather than under the badge.
export const headerSubtitleStyles = {
  marginLeft: '48px',
  minWidth: 0,
};

export const headerTitleActionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexShrink: 0,
  alignSelf: 'flex-start',
};

export const headerCloseButtonStyles = ({ palette }) => ({
  color: palette.text.secondary,
  padding: 0.5,
  '&:hover': {
    color: palette.text.primary,
    backgroundColor: palette.action.hover,
  },
});

export const headerIdentityBadgeStyles = ({ palette }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 36,
  height: 36,
  borderRadius: 2,
  color: palette.common.white,
  backgroundImage: `linear-gradient(135deg, ${COLOR_PALETTE.BLUE[6]}, ${COLOR_PALETTE.PURPLE[6]})`,
  boxShadow: palette.shadow?.s,
});

export const headerStripStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 3,
  flexWrap: 'wrap',
};

export const headerMetaStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 4,
  flexWrap: 'wrap',
};

export const headerMetaBlockStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  minWidth: 0,
};

export const headerMetaLabelStyles = {
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
};

export const headerMetaValueStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
};

export const headerProgressSlotStyles = {
  marginLeft: 'auto',
  width: 320,
  maxWidth: '100%',
};

export const masterDetailStyles = {
  display: 'flex',
  gap: 3,
  alignItems: 'stretch',
  width: '100%',
  minWidth: 0,
};

export const centerColumnStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  flex: 1,
  minWidth: 0,
};

export const transcriptStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

export const messageRowStyles =
  role =>
  ({ palette }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    padding: 1.5,
    borderRadius: 1,
    backgroundColor: role === 'user' ? palette.action.selected : palette.action.hover,
  });

export const messageMetaStyles = ({ palette }) => ({
  color: palette.text.secondary,
});

export const rawTabsStyles = ({ palette }) => ({
  display: 'flex',
  gap: 1,
  borderBottom: `1px solid ${palette.divider}`,
  paddingBottom: 1,
  marginBottom: 1,
});

export const rawTabStyles =
  isActive =>
  ({ palette }) => ({
    paddingX: 1.25,
    paddingY: 0.5,
    borderRadius: 1,
    cursor: 'pointer',
    backgroundColor: isActive ? palette.primary.main : 'transparent',
    color: isActive ? palette.primary.contrastText : palette.text.primary,
  });

export const rawBlobStyles = ({ palette }) => ({
  fontFamily: 'monospace',
  fontSize: 12,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  padding: 1,
  borderRadius: 1,
  backgroundColor: palette.action.hover,
  maxHeight: 320,
  overflow: 'auto',
});

export const emptyStateStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 4,
  borderRadius: 2,
  border: `1px dashed ${palette.divider}`,
  backgroundColor: palette.background.default,
  textAlign: 'center',
  color: palette.text.secondary,
});
